import React from 'react';
import { disciplines } from '../data/hero';
import { phases, tools } from '../data/system';
export function SystemOverview() {
  return <section aria-label="Sisteme genel bakış" className="bg-navy text-white" data-id="element-295" data-mp="18v0mymbbl32b">
      <div className="mx-auto max-w-6xl px-5 py-14 lg:py-20" style={{
      paddingTop: "20px",
      paddingBottom: "22px"
    }} data-id="element-296" data-mp="1mlcgmpnjz9vk">
        <div className="mx-auto max-w-3xl text-center" data-id="element-297" data-mp="1ho45va4qi84c">
          <h2 className="font-display text-3xl font-extrabold uppercase leading-none sm:text-5xl" data-id="element-298" data-mp="txgnfux7003j">
            UZUN MESAFE TRİATLON SİSTEMİ™
          </h2>
          <p className="mt-4 text-base leading-relaxed text-white/70 sm:text-lg" data-id="element-299" data-mp="pyhmelel0nhd">
            Hazırlığını rastgele antrenman programlarından, birbirinden kopuk tavsiyelerden ve sayısız
            internet sekmesinden bir araya getirmek istemeyen sporcular için kapsamlı bir sistem.
          </p>
          <p className="mt-5 flex flex-wrap items-center justify-center gap-x-2.5 gap-y-1 text-sm font-semibold uppercase tracking-wider text-white" data-id="element-300" data-mp="2fdfoe94b2akk">
            {disciplines.map((d, i) => <React.Fragment key={d} data-id="element-301" data-mp="235ulp9gdxb8i" data-mpi={i}>
                {i > 0 && <span className="text-aqua" aria-hidden="true" data-id="element-302" data-mp="28577rrzfmea1">·</span>}
                <span data-id="element-303" data-mp="287jxirbflsxn">{d}</span>
              </React.Fragment>)}
          </p>
          <p className="mt-3 text-sm text-white/50" data-id="element-304" data-mp="2d53c5sc1k7q4">Hepsi tek bir hazırlık çerçevesinde.</p>
        </div>

        <p className="mt-12 text-center text-xs font-bold uppercase tracking-[0.25em] text-aqua" data-id="element-305" data-mp="2i34wegl7ed36">
          Bir sistem · 6 aşama · 4 ücretsiz bonus
        </p>
        <p className="mt-3 text-center font-display text-2xl font-extrabold uppercase" data-id="element-306" data-mp="1pefz6sn9qrwp">
          6 Aşamalı Uzun Mesafe Triatlon Planı
        </p>

        <ol className="relative mt-8 grid gap-5 lg:grid-cols-6 lg:gap-4" data-id="element-307" data-mp="1ucrcjdcrvkjo">
          <span aria-hidden="true" className="absolute bottom-3 left-[17px] top-3 w-px bg-electric/50 lg:bottom-auto lg:left-[18px] lg:right-[18px] lg:top-[17px] lg:h-px lg:w-auto" data-id="element-308" data-mp="1z5ki23g2ewwt" />
          {phases.map((p, i) => <li key={p.n} className="relative flex items-start gap-4 text-left lg:flex-col lg:gap-3" data-id="element-309" data-mp="16n6pai9l614l" data-mpi={i}>
              <span className={i === phases.length - 1 ? 'relative flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-electric font-display text-sm font-bold text-white' : 'relative flex h-9 w-9 shrink-0 items-center justify-center rounded-full border-2 border-electric bg-navy font-display text-sm font-bold text-white'} data-id="element-310" data-mp="ym7gopjvfa54">
                {p.n}
              </span>
              <div data-id="element-311" data-mp="fpz759jtsd40">
                <p className="font-display text-xl font-bold uppercase leading-tight" data-id="element-312" data-mp="fpfzqmrsx748">{p.name}</p>
                <p className="mt-0.5 text-sm leading-snug text-white/60" data-id="element-313" data-mp="are8hek821ho">{p.short}</p>
              </div>
            </li>)}
        </ol>

        <div className="mt-12 border-t border-white/10 pt-8" data-id="element-314" data-mp="ko0rrywwgkhl">
          <p className="text-center text-xs font-bold uppercase tracking-[0.25em] text-white/50" data-id="element-315" data-mp="kmfyecmbn7lb">
            Üstelik 4 ücretsiz bonus!
          </p>
          <ul className="mt-6 grid grid-cols-2 gap-x-4 gap-y-6 lg:grid-cols-4" data-id="element-316" data-mp="1w3fxbr36ckob">
            {tools.map(({
            verb,
            name,
            icon: Icon
          }) => <li key={verb} className="flex items-start gap-3" data-id="element-317" data-mp="23ldt6ssfnx92">
                <Icon className="mt-0.5 h-5 w-5 shrink-0 text-aqua" aria-hidden="true" data-id="element-318" data-mp="28m1s00mwlidu" />
                <div data-id="element-319" data-mp="1umiqhqoll5ai">
                  <p className="font-display text-lg font-bold uppercase leading-none text-white" data-id="element-320" data-mp="1unbx8rnk3usn">{verb}</p>
                  <p className="mt-1 text-xs leading-snug text-white/60" data-id="element-321" data-mp="1yo47no8605qi">{name}</p>
                </div>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}